{
  "settings": "Setări",
  "yourDigitalAssistant": "Asistentul dvs. digital",
  "getStarted": "Începeți",
  "login": "Autentificare",
  "loggingIn": "Conectare ...",
  "darkMode": "Mod întunecat",
  "clearHistory": "Șterge istoricul",
  "historyCleared": "Istoria a fost ștearsă",
  "changeLanguage": "Limbă",
  "termsAndConditions": "Termeni de utilizare",
  "messagePlaceholder": "Tastați-vă mesajul aici ...",
  "messagePlaceholderDisabled": "Tastarea este dezactivată ...",
  "feedbackTitle": "Evaluați-vă experiența",
  "feedbackPlaceholder": "Spuneți-ne despre asta (opțional)",
  "feedbackSend": "Trimiteți",
  "feedbackClose": "Închide",
  "sessionExpired": "Sesiunea dvs. a expirat din cauza inactivității.",
  "startNewSession": "Începeți o nouă sesiune",
  "apiError": "Hopa! Ceva nu a funcționat corect. Ne străduim să reparăm acest lucru cât mai curând posibil.",
  "apiErrorOffline": "Nu sunteți conectat la internet.",
  "tryAgain": "Încercați din nou",
  "startOver": "Reîncepe",
  "chatEnded": "Chatul s-a încheiat.",
  "chatEndedThankYou": "Vă mulțumim că ați discutat cu noi!",
  "closeChat": "Închide",
  "startNewChat": "Chat din nou",
  "humanTakeoverStarted": "Acum sunteți transferat la serviciul pentru clienți ...",
  "humanTakeoverQueued": "Se așteaptă să vă conectați la un agent",
  "humanTakeoverAnAgent": "Un agent",
  "humanTakeoverAgentEntered": "a intrat în conversație",
  "humanTakeoverAgentLogout": "a părăsit conversația",
  "humanTakeoverTransfer": "Sunteți transferat la un agent nou",
  "humanTakeoverEnded": "Discutați acum cu asistentul dvs. digital",
  "version": "Versiune",
  "formIntroText": "Vă rugăm să completați următorul formular pentru a începe să discutați cu noi.",
  "formFirstName": "Prenume",
  "formLastName": "Numele de familie",
  "formName": "Nume",
  "formEmail": "E-mail",
  "formWrongEmail": "Vă rugăm să furnizați o adresă de e-mail validă.",
  "formPhone": "Telefon",
  "formShipmentId": "ID-ul expedierii",
  "formQuestion": "Întrebarea ta",
  "formAccountNumber": "Număr de cont (pentru clienții de afaceri)",
  "formAddress": "Abordare",
  "formPostcode": "Cod poștal",
  "formCity": "Oraș",
  "formCountry": "țară",
  "formSubmitButton": "Începeți chatul",
  "formEmptyFieldError": "Nu este permis să fie gol.",
  "formPhoneNumberValidationError": "Nu este un număr de telefon valid.",
  "formInputIsBiggerThan50": "Trebuie să aibă cel mult 50 de caractere.",
  "formInputIsBiggerThan100": "Trebuie să aibă cel mult 100 de caractere.",
  "formInputIsBiggerThan2000": "Trebuie să aibă cel mult 2000 de caractere.",
  "widgetEventOnline": "Mesaj DA: Utilizatorul este din nou online.",
  "widgetEventHidden": "Mesaj DA: Widgetul este ascuns.",
  "widgetEventVisible": "Mesaj DA: Widgetul este vizibil.",
  "widgetEventVisibleMinimized": "Mesaj DA: Widgetul este vizibil, dar minimizat.",
  "widgetEventMinimized": "Mesaj DA: Widgetul este minimizat.",
  "widgetEventMaximized": "Mesaj DA: Widgetul este maximizat.",
  "widgetEventSessionExpired": "Mesaj DA: sesiunea Widget a expirat.",
  "widgetEventHangupHuman": "Mesaj DA: Utilizatorul încheie sesiunea de preluare umană.",
  "widgetEventUserTyping": "Mesaj DA: utilizatorul tastează.",
  "fileTooLarge": "Încercați să atașați fișiere prea mari.",
  "tooManyDiles": "Încercați să atașați prea multe fișiere.",
  "fileInvalidType": "Încercați să atașați tipuri de fișiere nevalide.",
  "attachmentsDropHere": "Plasați aici pentru a încărca sau",
  "attachmentsBrowse": "Cauta fisiere",
  "attachmentsExtenstionQuantity": "pdf sau imagini (până la 10 fișiere)",
  "attachmentsSize": "până la 30 MB",
  "attachmentsFailedUploading": "Încărcarea nu a reușit",
  "attachmentsUploading": "Se încarcă ...",
  "minimizeExpandText": "Chat live cu noi acum!",
  "popupWidgetNotificationMessage": "Ai primit un mesaj nou!",
  "tabWidgetNotificationMessage": "Mesaj nou!",
  "datepickerSendButton": "Trimite"
}
